// hooks/useScrollAnimation.js

// ─── The cinematic easing curve ─────────────────────────────────────────────
// Starts almost imperceptibly slow, accelerates through the middle,
// then decelerates into a silky soft landing — like a camera dolly move
const EASE = [0.16, 1, 0.3, 1];

// ─── Core variants ───────────────────────────────────────────────────────────

export const fadeUp = {
  hidden: {
    opacity: 0,
    y: 56,
    filter: "blur(4px)",
  },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 1.0,
      ease: EASE,
    },
  },
};

export const fadeIn = {
  hidden: {
    opacity: 0,
    filter: "blur(6px)",
  },
  show: {
    opacity: 1,
    filter: "blur(0px)",
    transition: {
      duration: 1.1,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

export const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -60,
    filter: "blur(4px)",
  },
  show: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      duration: 1.0,
      ease: EASE,
    },
  },
};

export const fadeRight = {
  hidden: {
    opacity: 0,
    x: 60,
    filter: "blur(4px)",
  },
  show: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      duration: 1.0,
      ease: EASE,
    },
  },
};

export const scaleIn = {
  hidden: {
    opacity: 0,
    scale: 0.92,
    filter: "blur(6px)",
  },
  show: {
    opacity: 1,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 1.05,
      ease: EASE,
    },
  },
};

// Rises up + very slight rotation — gives organic life to hero elements
export const heroReveal = {
  hidden: {
    opacity: 0,
    y: 40,
    rotateX: 8,
    filter: "blur(8px)",
  },
  show: {
    opacity: 1,
    y: 0,
    rotateX: 0,
    filter: "blur(0px)",
    transition: {
      duration: 1.1,
      ease: EASE,
    },
  },
};

// Gentle float up from deeper — used for section headings
export const sectionReveal = {
  hidden: {
    opacity: 0,
    y: 70,
    filter: "blur(3px)",
  },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 1.15,
      ease: EASE,
    },
  },
};

// ─── Stagger containers ───────────────────────────────────────────────────────

// Standard stagger — cards, badges, rows
export const staggerContainer = (
  staggerChildren = 0.18,
  delayChildren = 0.05
) => ({
  hidden: {},
  show: {
    transition: {
      staggerChildren,
      delayChildren,
    },
  },
});

// Tighter stagger for small inline items (buttons, chips)
export const staggerContainerFast = (
  staggerChildren = 0.1,
  delayChildren = 0
) => ({
  hidden: {},
  show: {
    transition: {
      staggerChildren,
      delayChildren,
    },
  },
});

// ─── Stagger children ─────────────────────────────────────────────────────────

// Standard card stagger child — rises with blur dissolve
export const staggerItem = {
  hidden: {
    opacity: 0,
    y: 40,
    filter: "blur(4px)",
  },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.95,
      ease: EASE,
    },
  },
};

// Softer child for text/inline elements
export const staggerItemSoft = {
  hidden: {
    opacity: 0,
    y: 20,
    filter: "blur(2px)",
  },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.9,
      ease: EASE,
    },
  },
};

// Scale-up child — for stat cards, icon badges
export const staggerItemScale = {
  hidden: {
    opacity: 0,
    scale: 0.88,
    y: 20,
    filter: "blur(4px)",
  },
  show: {
    opacity: 1,
    scale: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.95,
      ease: EASE,
    },
  },
};
